/*
 * @Description: 待支付
 * @Date: 2020-12-12 17:43:20
 */

import fields, {
  createTotalPayment,
  getPayStatusTextMap,
  reMark,
  createCurrentPayAmount
} from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { csoCustomerOrder } from '@/api/ajax';
import { userEnterpriseType as userEnterpriseTypeSearch } from '@/page/settlementCenter/common/tableConfig/search.js';
import { userEnterpriseType as userEnterpriseTypeField } from '@/page/settlementCenter/common/tableConfig/fields.js';

import {
  bankRowLabelFiled,
  bankSearchFiled,
  payTypeRowLabelFiled,
  payTypeSearchFiled
} from '@/common/fields/bank'; // 在这混入兼容方便兼容之前数据
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';
import { payStatusIcon } from '@/common/fields/order';

let example = new TableRenderClass({ fields, search });
const batchPart = example.createPart({
  name: '按生成批次展示',
  search: [
    'orderNo',
    'batchOrderNo',
    'projectName',
    userEnterpriseTypeSearch,
    'dingdanshengchengshijian',
    'zhifujiezhishijian',
    'paymentDeadline',
    'payStatusCascader',
    'feeType',
    'industrial',
    bankSearchFiled,
    payTypeSearchFiled
  ],
  list: csoCustomerOrder.unPayOrderList,
  defaultQuery: {
    tag: 1
  },
  requestNow: true,
  fields: [
    {
      type: 'selection',
      width: '40px',
      reserve: true,
      selectable(row) {
        // 关闭支付、线下完成支付的订单
        if (+row.closeFlag) {
          return false;
        }
        // 正常支付，部分成功与失败
        if ([2, 4].includes(row.payStatus)) {
          return true;
        }
        // 审核通过与审核中 不可在选择
        if ([1, 2].includes(row.authStatus) || row.gongyeAuditStatus === 1) {
          return false;
        }
        // 2 服务费并且对应订单已勾选，不可勾选
        if (row.selectable === 2) {
          return false;
        }
        // 无支付项目ID则不可操作
        if (!row.noPayCsoCustomOrderIds) {
          return false;
        }
        return row.payStatus !== 1;
      }
    },
    'index',
    'batchOrderNo',
    bankRowLabelFiled[PAY_BANK_TYPE_KEY],
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    { id: 'daizhifudingdanshengchengshijian', label: '生成时间' },
    userEnterpriseTypeField,
    createTotalPayment(1, '订单总金额', 'orderPrice'),
    createCurrentPayAmount('currentPayAmount'),
    'feeType',
    reMark(),
    '_paymentProgress',
    {
      label: '支付状态',
      prop: 'payStatus',
      width: '120px',
      render: (h, ctx, r) => {
        function getLabel() {
          if (r.priceType === 1) {
            // 项目类型-支付状态为-
            return '-';
          } else {
            // 审核状态优先级最高 authStatus 1审核中 3审核不通过
            if (r.authStatus === 3) {
              return '支付失败';
            } else if (r.authStatus === 1) {
              return '支付中';
            } else {
              return getPayStatusTextMap(r.priceType)[r.payStatus];
            }
          }
        }
        return (
          <div>
            <span>{getLabel()}</span>
            {payStatusIcon(h, ctx, r)}
          </div>
        );
      }
    },
    // 'zhifuzhuangtai',
    'batchOperation'
  ],
  beforeSearch(search) {
    search.$parent.clearTableSelection();
  }
});
const projectPart = example.createPart({
  name: '按项目展示',
  search: [
    'orderNo',
    'batchOrderNo',
    'projectName',
    userEnterpriseTypeSearch,
    'dingdanshengchengshijian',
    'zhifujiezhishijian',
    'paymentDeadline',
    'payStatusCascader',
    'feeType',
    'remark',
    'industrialReal',
    bankSearchFiled,
    payTypeSearchFiled
  ],
  list: csoCustomerOrder.unPayOrderList,
  defaultQuery: {
    tag: 2
  },
  requestNow: true,
  fields: [
    {
      type: 'selection',
      width: '40px',
      reserve: true,
      selectable(row) {
        // 关闭支付、线下完成支付的订单
        const isCloseOrrgType =
          !!+row.closeOrRgType && [1, 2].includes(+row.closeOrRgStatus);
        if (isCloseOrrgType) {
          return false;
        }
        // 正常支付，部分成功与失败
        if ([2, 4].includes(row.payStatus)) {
          return true;
        }
        // 审核通过与审核中 不可在选择
        if ([1, 2].includes(row.authStatus) || row.gongyeAuditStatus === 1) {
          return false;
        }
        // 2 服务费并且对应订单已勾选
        if (row.selectable === 2) {
          return false;
        }
        return row.payStatus !== 1;
      }
    },
    'index',
    'orderNo',
    'projectName',
    'batchOrderNo',
    bankRowLabelFiled[PAY_BANK_TYPE_KEY],
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'daizhifudingdanshengchengshijian',
    'zhifujiezhishijian',
    userEnterpriseTypeField,
    'industryName',
    createTotalPayment(1, '订单总金额', 'orderPrice'),
    createCurrentPayAmount('currentPayAmount'),
    'feeType',
    'remark',
    '_paymentProgress',
    'zhifuzhuangtai',
    'operation'
  ],
  beforeSearch(search) {
    search.$parent.clearTableSelection();
  }
});
export default {
  name: '待支付订单',
  childMenu: [projectPart, batchPart]
};
